
import { appConst, Component, FormPageMixins, Mixins, PageResultBaseMixins, PageResultModalMixins } from "@/lib";
import DeclareCustoms from "@/store/modules/shipment/declarecustoms/entity";
import DeclareGroup from "@/store/modules/shipment/declaregroup/entity"
import DeclareProductList from "@/store/modules/shipment/declareproductlist/entity";

import CreateDeclareGroupModel from "./component/create-declare-group.vue"
import CopyDeclareGroupModel from "./component/copy-declare-group.vue"
import CardTitleView from "@/components/card-title/index.vue"

class EditRow {
  index: number;
  data: DeclareGroup;

  constructor() {
    this.index = -1;
    this.data = new DeclareGroup();
  }
}

@Component({components: {CreateDeclareGroupModel, CopyDeclareGroupModel, CardTitleView}})
export default class DeclareGroupView extends Mixins(FormPageMixins, PageResultBaseMixins, PageResultModalMixins) {
  model = new DeclareCustoms();
  editRow:EditRow = new EditRow();

  setSizeUnit(unit) {
    return unit === this.$appconst.unit.size;
  }
  setdotNumber(isSizeUnit) {
    return isSizeUnit ? 2 : 0;
  }

  quantity(row) {
    let dotNumber = this.setdotNumber(this.setSizeUnit(row.unit));
    return !!row.quantity || row.quantity === 0 ? row.quantity.toFixed(dotNumber) : row.quantity
  }

  get record() {
    let result = this.$store.state.shipment.declaregroup.declareCustomsDetail as DeclareCustoms;
    if (result) {
      // 币种：如果【销售类型】是内销，则币种为RMB，不能修改。若为外销，则默认USD，可修改
      if (result.salesType == appConst.salesType.domesticSales) {
        result.currency = appConst.currency.RMB;
      } else if(!result.currency) {
        result.currency = appConst.currency.USD;
      }
    }
    
    return result;
  }

  // 收汇登记状态是否为确认中、已确认
  get incomeConfirming() {
    return this.model.customerConfirmStatus !== appConst.confirmStatus.toBeConfirmed;
  }

  // 收汇登记状态是否为已确认
  get incomeConfirmed() {
    return this.model.customerConfirmStatus === appConst.confirmStatus.confirmed;
  }
  
  get column() {
    return [
      this.$util.render.baseColumn("app.SystemCode.SequenceNo", 80, {key: "rowIndex", align: 'center'}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductName", null, {key: "productName", slot: "productName",minWidth: 200}),
      this.$util.render.baseColumn("app.DeclareGroup.BoxCount", null, {key: "boxCount", minWidth: 120, align: 'right'}),
      this.$util.render.baseColumn("app.DeclareGroup.Quantity", null, {slot: "quantity", key: "quantity", minWidth: 120, align: 'right'}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalGrossWeight", null, {key: "totalGrossWeight", minWidth: 120, align: 'right', render: (h: any, params: any) => {
        return [h("span", !!params.row.totalGrossWeight || params.row.totalGrossWeight === 0 ? params.row.totalGrossWeight.toFixed(2) : "")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalNetWeight", null, {key: "totalNetWeight", minWidth: 120, align: 'right', render: (h: any, params: any) => {
        return [h("span", !!params.row.totalNetWeight || params.row.totalNetWeight === 0 ? params.row.totalNetWeight.toFixed(2) : "")];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.Price", null, {key: "price", minWidth: 120, align: 'right', render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.price))];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.TotalAmount", null, {key: "totalAmount", minWidth: 120, align: 'right', render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.totalAmount))];
      }}),
      this.$util.render.baseColumn("app.DeclareGroup.ProductCode", null, {key: "productCode", minWidth: 120}),
      this.$util.render.baseColumn("app.Factory.FactoryName", null, {key: "factoryName", minWidth: 180}),
      this.$util.render.baseColumn("app.DeclareGroup.RmbAmount", null, {key: "rmbAmount", minWidth: 120, align: 'right', render: (h: any, params: any) => {
        return [h("span", this.$util.format.amount(params.row.rmbAmount))];
      }}),
      this.$util.render.baseColumn("app.DeclareCustoms.DomesticSourceOfGood", null, {key: "domesticSourceOfGood", minWidth: 100}),
      this.$util.render.baseColumn("Action.Actions", null, {key: "actions", slot: "actions", minWidth: 100, fixed: 'right'})
    ];
  }

  get shipmentList() {
    let list = [];
    if (!!this.model.declareGroupList && this.model.declareGroupList.length > 0) {
      const poNumberText = this.L('app.DeclareGroup.PoNumber');
      this.model.declareGroupList.forEach((item, index) => {
        // 当PO#和总品名都没有填写，则Talbe中不增加组名行
        let hasGroup = false;
        let childLength = item.productList.length;
        if (!!item.poNumber || !!item.groupName) {
          list.push({
            rowspan: childLength + 1,
            isGroup: true,
            isTitle: true,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            poNumber: !!item.poNumber ? `${poNumberText}${item.poNumber}` : "",
            groupName: item.groupName
          })
          hasGroup = true;
        }
        
        item.productList.forEach((productItem, productItemIndex) => {
          list.push({
            rowspan: hasGroup || productItemIndex !== 0 ? 0 : childLength,
            isGroup: false,
            isTitle: !hasGroup,
            dataIndex: index,// 序号
            rowIndex: index + 1,// 显示的序号
            productName: `${productItem.productNameEn}/${productItem.productName}`,
            boxCount: productItem.boxCount,
            quantity: productItem.quantity,
            totalGrossWeight: productItem.totalGrossWeight,
            totalNetWeight: productItem.totalNetWeight,
            price: productItem.price,
            totalAmount: productItem.totalAmount,
            rmbAmount: productItem.rmbAmount,
            productCode: productItem.productCode,
            unit: productItem.unit,
            factoryId: productItem.factoryId,
            factoryName: productItem.factoryName,
            domesticSourceOfGood: productItem.domesticSourceOfGood
          })
        })
      })
    };
    return list;
  }

  get currencyList() {
    return this.getCodeListByCategory(appConst.codeCategory.currency)
  }

  async created() {
    Object.assign(this.config,{
      labelWidth: 0,
      isRedirectIndex: false,
      getAction: "shipment/declaregroup/getShipmentListDetail",
      okAction: "shipment/declaregroup/saveShipmentList"
    })
    
    await this.$store.dispatch("system/productname/getProductNameSelect");
  }

  handleCreate() {
    this.editRow.index = -1;
    this.$store.commit("shipment/declaregroup/edit", new DeclareGroup());
    this.open("create-declare-group-model");
  }

  /**
   * 创建成功
   */
  createSuccess(value) {
    if (this.editRow.index > -1) {
      this.model.declareGroupList[this.editRow.index].poNumber = value.poNumber;
      this.model.declareGroupList[this.editRow.index].groupName = value.groupName;
      this.model.declareGroupList[this.editRow.index].productList = value.productList;
    } else {
      this.model.declareGroupList.push(value);
    }
    
  }

  handleCopy() {
    this.open("copy-declare-group-model");
  }

  /**
   * 复制成功
   */
  copySuccess(value: DeclareCustoms) {
    if (value && value.declareGroupList && value.declareGroupList.length > 0) {
      value.declareGroupList.forEach(item => {
        if (item.isCopy) {
          item.id = 0;
          item.originalId = value.id;
          this.model.declareGroupList.push(item);
        }
      })
    }
    
  }

  /**
   * 编辑
   */
  handleEdit(index) {
    this.editRow.index = index;
    let groupData = {
      editRowIndex: index,
      poNumber: this.model.declareGroupList[index].poNumber,
      groupName: this.model.declareGroupList[index].groupName,
      productList: new Array<DeclareProductList>(),
    }
    this.model.declareGroupList[index].productList.forEach(item => {
      groupData.productList.push(this.$util.assign(item) as DeclareProductList);
    });
    this.$store.commit("shipment/declaregroup/edit", groupData);
    this.open("create-declare-group-model");
  }

  handleDelete(index) {
    this.model.declareGroupList.splice(index, 1);
  }

  /**
   * 合并单元格
   */
  handleSpan ({ row, column, rowIndex, columnIndex }) {
    if (columnIndex == 0) {
      return {
          rowspan: row.rowspan,
          colspan: 1
      };
    }
  }

  handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.Common.Total');
    const NA = 'N/A';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0 || index === 8 || index === 9) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        if (index === 6) {
            sums[key] = {
                key,
                value: NA
            };
            return;
        }
        if (index === 1) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        let haveSizeUnit = (data as Array<any>).some((item)=> {
          return this.setSizeUnit(item.unit);
        });
        let dotNumber = this.setdotNumber(haveSizeUnit);
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            const v = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                    return prev + curr;
                } else {
                    return prev;
                }
            }, 0);
            let amountText = "";
            switch(key) {
              case "totalAmount": 
                amountText = this.$util.format.amount(v);
                break;
              case "boxCount":
                amountText = v.toFixed(0);
                break;
              case "quantity":
                amountText = v.toFixed(dotNumber);
                break;
              default:
                amountText = v.toFixed(2);
                break;
            }
            sums[key] = {
                key,
                value: amountText
            };
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }

  rowClassName (row, index) {
    if (row.isTitle) {
      return 'hi-table-group-row';
    }
    return '';
  }

  formatTotalVolume(value: string): string {
    if (!value && value !== '0') return '';
    const num = parseFloat(value);
    if (isNaN(num)) return value;
    const fixed = num.toFixed(3);
    return fixed.endsWith('0') ? num.toFixed(2) : fixed;
  }

  parseTotalVolume(value: string): string {
    return (value || '').replace(/,/g, '');
  }

  saveSuccss() {
    this.$router.push({ name: "declarecustoms.list" });
  }
}
